import { render, staticRenderFns } from "./facilities.vue?vue&type=template&id=519d6b07&scoped=true&"
import script from "./facilities.vue?vue&type=script&lang=js&"
export * from "./facilities.vue?vue&type=script&lang=js&"
import style0 from "./facilities.vue?vue&type=style&index=0&id=519d6b07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d6b07",
  null
  
)

export default component.exports